export function localStorageEnabled(): boolean {
    const key = 'bek-local-storage-enabled';
    try {
        if (window.localStorage) {
            window.localStorage.setItem(key, 'true');
            const got = window.localStorage.getItem(key);
            window.localStorage.removeItem(key);
            return got === 'true';
        }
        return false;
    } catch {
        // Accessing localStorage will throw an error if it's not enabled.
        return false;
    }
}